__webpack_require__.p = "/tokens-x-social/account-setup/";